import React, { useState } from 'react';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import { Button } from 'react-bootstrap';
import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import Card from '~/components/Card';
import { authRetrievePassword } from '~/stores/redux/common/authSlice';
import { authLogin } from '~/stores/redux/common/authSlice';

const loginSchema = Yup.object().shape({
    email: Yup.string().email().required(),
    password: Yup.string().required(),
});

function Login() {
    const [error, setError] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    const { isLoading } = useSelector((state) => state.loading);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handleRetrievePassword = (e) => {
        e.preventDefault();
        dispatch(authRetrievePassword(navigate));
    };

    return (
        <div
            className="block-center mt-4 wd-xl"
            style={{ position: 'relative' }}
        >
            <Card
                header={'Halfwish'}
                headerClassName={'bg-dark text-white'}
                tagLevel={2}
                isLoading={isLoading}
            >
                <p className="text-center py-2">SIGN IN TO CONTINUE.</p>
                <Formik
                    initialValues={{
                        email: '',
                        password: '',
                    }}
                    validationSchema={loginSchema}
                    onSubmit={(values, formikBag) => {
                        dispatch(
                            authLogin({
                                email: values.email,
                                password: values.password,
                                setError,
                                setErrorMsg,
                                formikBag,
                            }),
                        );
                    }}
                >
                    {({ isSubmitting }) => (
                        <Form noValidate>
                            <div className="form-group">
                                <Field
                                    name="email"
                                    type="email"
                                    disabled={isSubmitting}
                                    autoComplete="username email"
                                    className="form-control"
                                    placeholder="Email"
                                />
                                <ErrorMessage
                                    component="div"
                                    className="invalid-feedback d-block"
                                    name="email"
                                />
                            </div>

                            <div className="form-group">
                                <Field
                                    type="password"
                                    name="password"
                                    disabled={isSubmitting}
                                    autoComplete="new-password"
                                    className="form-control mt-3"
                                    placeholder="Password"
                                />
                                <ErrorMessage
                                    component="div"
                                    className="invalid-feedback d-block"
                                    name="password"
                                />
                            </div>

                            <div className={`form-main mt-4`}>
                                {error && (
                                    <div
                                        className="py-3 mb-4"
                                        style={{ color: 'red' }}
                                    >
                                        {errorMsg}
                                    </div>
                                )}
                            </div>
                            <Button
                                className="font-bolder w-100 btn btn-primary btn-block "
                                type="submit"
                                disabled={isSubmitting}
                            >
                                Login
                            </Button>
                            <div className="clearfix mt-2">
                                <div className="float-right">
                                    <a
                                        className="text-muted"
                                        onClick={handleRetrievePassword}
                                        href="#"
                                    >
                                        Forgot your password?
                                    </a>
                                </div>
                            </div>
                        </Form>
                    )}
                </Formik>
            </Card>
        </div>
    );
}

export default Login;
